import React, { Component } from "react";

export default class NewTea extends Component {
    render() {
      return (

        <div className="newtea">
        <div>
          <img src="/11.jpeg" className="figure-img img-fluid"/>
          <img src="/44.jpg" className="figure-img img-fluid"/>
        </div>
      </div>


      );
      }
    }